import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeFieldType } from './types';

const getIncomeFieldTypes: QueryFunction<
  IncomeFieldType[],
  ['/income-field-types', string]
> = async ({ queryKey }) => {
  const documentTypeId = queryKey[1];
  if (isMockServices())
    return await mock(_mockIncomeFieldTypes(documentTypeId));

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: IncomeFieldType[];
  }>(`/income-field-types/${documentTypeId}`, { method: 'GET' });

  return response.data?.data ?? [];
};

export default getIncomeFieldTypes;

const _mockIncomeFieldTypes = (documentTypeId: string): IncomeFieldType[] =>
  [
    { name: 'base_wage', displayName: 'Base Wage' },
    { name: 'overtime', displayName: 'Overtime' },
    { name: 'bonus', displayName: 'Bonus' },
  ].map((f, index) => ({
    ...f,
    id: `ift-${index}`,
    documentTypeId,
    inUse: true,
    isDeleted: false,
  }));
